import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

// V2 Emotional Progress Card — sits directly under the Hero on Dashboard.
// Pure presentational: receives lines from /users/me/journey.
export default function EmotionalProgressCard({ lines }) {
  if (!Array.isArray(lines) || lines.length === 0) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.05 }}
      className="gm-card p-4"
      data-testid="journey-card"
    >
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-xl bg-[#FFC800]/15 flex items-center justify-center">
          <Sparkles size={16} color="#FFC800" strokeWidth={3} />
        </div>
        <h3 className="text-sm font-extrabold uppercase text-[#4B4B4B] tracking-wider">
          Your Journey So Far
        </h3>
      </div>
      <ul className="space-y-2">
        {lines.map((line, idx) => (
          <li
            key={idx}
            className="text-[15px] font-extrabold text-[#1F2937] leading-snug flex items-start gap-2"
            data-testid={`journey-line-${idx}`}
          >
            <span className="text-[#1CB0F6] mt-1 text-lg leading-none">·</span>
            <span>{line}</span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
}
